import config from "@/config"
import http from "@/utils/request"

export default {
	token: {
		url: `${config.API_URL}/token`,
		name: "登录获取TOKEN",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		}
	},
	login: {
		url: `${config.API_URL}/login/auth`,
		name: "登录",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		}
	},

	getCaptcha: {
		url: `${config.API_URL}/user/getCaptcha`,
		name: "获取图形验证码",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
	},

	sendSms: {
		url: `${config.API_URL}/user/sendSms`,
		name: "发送短信",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
	},

	webLogin: {
		url: `${config.API_URL}/user/webLogin`,
		name: "web登录[手机号+验证码]",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
	},

	getSiteConfig: {
		url: `${config.API_URL}/init/getSiteConfig`,
		name: "获取贴牌等配置信息",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
	},

	webAccountLogin: {
		url: `${config.API_URL}/user/webAccountLogin`,
		name: "web登录[手机号+密码] 副本",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		}
	},
}
